import {useLocation } from "react-router-dom";
import PageTitleSlim from "../../components/PageTitleSlim/PageTitleSlim.jsx";
import SectionTitle from "../../components/SectionTitle/SectionTitle.jsx";

const ErrorPage = () => {
    const location = useLocation();
    const errorMessage = location.state?.message || "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
    const errorStatus = location.state?.status || 500;
    const astorId = location.state?.astorId || null;
    const buttonText = location.state?.buttonText || null;
    const buttonLink = location.state?.link || null;
    const secondaryHintLine = location.state?.hasSecondaryHintLine || false;
    const isPdf404Error = location.state?.isPdf404Error || false;
    return (
        <>
            <PageTitleSlim title={`Fehler ${errorStatus}`}/>
            <section className="container narrow">
                <SectionTitle title={`Ups...ein ${errorStatus} Fehler`}/>
                <div className="section-inner">
                    <div className="form-container">
                        <h3>{errorMessage}</h3>
                        {
                            isPdf404Error &&
                            <>
                                <hr/>
                                <p>Mögliche Ursachen:</p>
                                <p>- Das PDF-Dokument ist abgelaufen. Aus technischen Gründen können wir PDF-Bestellungen
                                    nur 14 Tage zur Verfügung stellen. </p>
                                <p>- Der Link ist fehlerhaft.</p>

                                <p>Bitte bestellen Sie die von Ihnen gewünschte PDF-Datei erneut.</p>
                            </>
                        }
                        {astorId &&
                            <>
                                <hr/>
                                <p>
                                    Zurück zum <a href={`https://onb.digital/result/${astorId}`}>digitalisierten
                                    Objekt</a>
                                </p>
                            </>
                        }
                        <hr/>
                        <p>Hier gelangen Sie zu den digitalisierten Objekten der Österreichischen Nationalbibliothek: <a
                            href="https://onb.digital">onb.digital</a></p>
                        <p>Hier gelangen Sie zum <a href="https://search.onb.ac.at">Katalog</a></p>
                        {secondaryHintLine &&
                            <>
                                <hr/>
                                <p>Sollte es wiederholt zu Problemen kommen, wenden Sie sich bitte an
                                    digital@onb.ac.at</p>
                            </>
                        }
                        {buttonText && buttonLink && (
                            <a
                                href={buttonLink}
                                className="button primary hollow"
                                style={{display: "inline-block", textDecoration: "none"}}
                            >
                                {buttonText}
                            </a>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default ErrorPage;
